var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBarbuss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 864,
    zoomAndPan: "magnify",
    viewBox: "0 0 648 294.749989",
    height: 393,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ab28fa6140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 75.117188 77.398438 L 113 77.398438 L 113 115.351562 L 75.117188 115.351562 Z M 75.117188 77.398438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "51b93e92c8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 112.859375 77.4375 L 112.859375 115.136719 L 75.160156 115.136719 Z M 112.859375 77.4375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "82c4f97b87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.117188 0.398438 L 38 0.398438 L 38 38.1875 L 0.117188 38.1875 Z M 0.117188 0.398438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2e52747a66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 37.859375 0.4375 L 37.859375 38.136719 L 0.160156 38.136719 Z M 37.859375 0.4375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "10efe85049"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 38,
    y: 0,
    height: 39
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "78d8cc7e1c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.691406 8 L 113 8 L 113 115.351562 L 5.691406 115.351562 Z M 5.691406 8 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "022269d297"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 44.925781 115.136719 L 5.902344 115.136719 L 5.902344 76.160156 L 73.867188 8.179688 L 112.871094 8.179688 L 112.871094 47.207031 Z M 44.925781 115.136719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4bbce9fb7f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.890625 0 L 108 0 L 108 107.1875 L 0.890625 107.1875 Z M 0.890625 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "703334e93f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 39.925781 107.136719 L 0.902344 107.136719 L 0.902344 68.160156 L 68.867188 0.179688 L 107.871094 0.179688 L 107.871094 39.207031 Z M 39.925781 107.136719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3bbb9ce515"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 108,
    y: 0,
    height: 108
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1efe0e07f8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.691406 8 L 43.644531 8 L 43.644531 45.925781 L 5.691406 45.925781 Z M 5.691406 8 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3cb65f3595"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 43.625 8.179688 L 5.902344 8.179688 L 5.902344 45.902344 Z M 43.625 8.179688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bb71c3dab4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.890625 0 L 38.644531 0 L 38.644531 37.925781 L 0.890625 37.925781 Z M 0.890625 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cd0a694cc4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 38.625 0.179688 L 0.902344 0.179688 L 0.902344 37.902344 Z M 38.625 0.179688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8b3f12c174"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 39,
    y: 0,
    height: 38
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "07fe184d87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 143 8 L 197.113281 8 L 197.113281 114.960938 L 143 114.960938 Z M 143 8 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3d5de03443"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 169.792969 100.988281 C 176.523438 100.988281 180.121094 95.003906 180.121094 83.929688 C 180.121094 72.253906 175.476562 67.320312 168.59375 67.320312 L 159.765625 67.320312 L 159.765625 100.988281 Z M 168.292969 53.695312 C 175.175781 53.695312 179.820312 48.601562 179.820312 37.089844 C 179.820312 26.3125 175.773438 21.527344 169.792969 21.527344 L 159.765625 21.527344 L 159.765625 53.695312 Z M 143.144531 8.042969 L 172.929688 8.042969 C 188.050781 8.042969 196.277344 17.171875 196.277344 34.980469 C 196.277344 49.050781 190.585938 57.730469 182.054688 59.828125 L 182.054688 60.429688 C 192.082031 62.824219 197.015625 71.953125 197.015625 84.976562 C 197.015625 105.78125 187.4375 114.761719 173.816406 114.761719 L 143.144531 114.761719 Z M 143.144531 8.042969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "52cd8a1a89"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0546875 0 L 54.113281 0 L 54.113281 106.949219 L 0.0546875 106.949219 Z M 0.0546875 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "576a87d21b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.792969 92.988281 C 33.523438 92.988281 37.121094 87.003906 37.121094 75.929688 C 37.121094 64.253906 32.476562 59.320312 25.59375 59.320312 L 16.765625 59.320312 L 16.765625 92.988281 Z M 25.292969 45.695312 C 32.175781 45.695312 36.820312 40.601562 36.820312 29.089844 C 36.820312 18.3125 32.773438 13.527344 26.792969 13.527344 L 16.765625 13.527344 L 16.765625 45.695312 Z M 0.144531 0.0429688 L 29.929688 0.0429688 C 45.050781 0.0429688 53.277344 9.171875 53.277344 26.980469 C 53.277344 41.050781 47.585938 49.730469 39.054688 51.828125 L 39.054688 52.429688 C 49.082031 54.824219 54.015625 63.953125 54.015625 76.976562 C 54.015625 97.78125 44.4375 106.761719 30.816406 106.761719 L 0.144531 106.761719 Z M 0.144531 0.0429688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "75829fb380"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 55,
    y: 0,
    height: 107
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "53e1ff4c8b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 206.375 7.539062 L 272 7.539062 L 272 114.960938 L 206.375 114.960938 Z M 206.375 7.539062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a36bfbd94c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 247.003906 73.300781 L 238.773438 26.75 L 238.324219 26.75 L 229.796875 73.289062 Z M 228.148438 7.742188 L 250.898438 7.742188 L 271.851562 114.761719 L 255.09375 114.761719 L 249.699219 86.914062 L 227.097656 86.914062 L 222.015625 114.761719 L 206.445312 114.761719 Z M 228.148438 7.742188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bea5ad2ab8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.375 0.539062 L 66 0.539062 L 66 107.949219 L 0.375 107.949219 Z M 0.375 0.539062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6a2f725c59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.003906 66.300781 L 32.773438 19.75 L 32.324219 19.75 L 23.796875 66.289062 Z M 22.148438 0.742188 L 44.898438 0.742188 L 65.851562 107.761719 L 49.09375 107.761719 L 43.699219 79.914062 L 21.097656 79.914062 L 16.015625 107.761719 L 0.445312 107.761719 Z M 22.148438 0.742188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae736d1612"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 66,
    y: 0,
    height: 108
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9a0ef126f3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 283 8 L 338.804688 8 L 338.804688 114.960938 L 283 114.960938 Z M 283 8 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5eed1da130"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 309.117188 57.730469 C 316.445312 57.730469 320.492188 52.046875 320.492188 39.921875 C 320.492188 29.597656 317.34375 22.117188 308.816406 22.117188 L 299.835938 22.117188 L 299.835938 57.730469 Z M 283.066406 8.042969 L 310.164062 8.042969 C 327.523438 8.042969 337.25 18.371094 337.25 38.574219 C 337.25 53.835938 332.003906 63.125 323.777344 66.558594 L 338.449219 114.75 L 321.078125 114.75 L 308.664062 70.304688 L 299.835938 70.304688 L 299.835938 114.761719 L 283.066406 114.761719 Z M 283.066406 8.042969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "541e3474d9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 55.488281 0 L 55.488281 106.949219 L 0 106.949219 Z M 0 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5dab292172"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.117188 49.730469 C 33.445312 49.730469 37.492188 44.046875 37.492188 31.921875 C 37.492188 21.597656 34.34375 14.117188 25.816406 14.117188 L 16.835938 14.117188 L 16.835938 49.730469 Z M 0.0664062 0.0429688 L 27.164062 0.0429688 C 44.523438 0.0429688 54.25 10.371094 54.25 30.574219 C 54.25 45.835938 49.003906 55.125 40.777344 58.558594 L 55.449219 106.75 L 38.078125 106.75 L 25.664062 62.304688 L 16.835938 62.304688 L 16.835938 106.761719 L 0.0664062 106.761719 Z M 0.0664062 0.0429688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "67f022ecab"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 56,
    y: 0,
    height: 107
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a6791d0dc5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 351.007812 8.042969 L 405 8.042969 L 405 114.964844 L 351.007812 114.964844 Z M 351.007812 8.042969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "34741e634a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 377.644531 100.984375 C 384.375 100.984375 387.972656 95.003906 387.972656 83.929688 C 387.972656 72.253906 383.339844 67.320312 376.445312 67.320312 L 367.617188 67.320312 L 367.617188 100.984375 Z M 376.148438 53.695312 C 383.027344 53.695312 387.671875 48.601562 387.671875 37.089844 C 387.671875 26.3125 383.628906 21.527344 377.644531 21.527344 L 367.617188 21.527344 L 367.617188 53.695312 Z M 351.007812 8.042969 L 380.792969 8.042969 C 395.914062 8.042969 404.144531 17.171875 404.144531 34.980469 C 404.144531 49.050781 398.449219 57.730469 389.921875 59.828125 L 389.921875 60.425781 C 399.949219 62.824219 404.890625 71.953125 404.890625 84.976562 C 404.890625 105.78125 395.3125 114.757812 381.691406 114.757812 L 351.007812 114.757812 Z M 351.007812 8.042969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2098c57a7b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0078125 0.0429688 L 53.914062 0.0429688 L 53.914062 106.949219 L 0.0078125 106.949219 Z M 0.0078125 0.0429688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dcd19248c0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.644531 92.984375 C 33.375 92.984375 36.972656 87.003906 36.972656 75.929688 C 36.972656 64.253906 32.339844 59.320312 25.445312 59.320312 L 16.617188 59.320312 L 16.617188 92.984375 Z M 25.148438 45.695312 C 32.027344 45.695312 36.671875 40.601562 36.671875 29.089844 C 36.671875 18.3125 32.628906 13.527344 26.644531 13.527344 L 16.617188 13.527344 L 16.617188 45.695312 Z M 0.0078125 0.0429688 L 29.792969 0.0429688 C 44.914062 0.0429688 53.144531 9.171875 53.144531 26.980469 C 53.144531 41.050781 47.449219 49.730469 38.921875 51.828125 L 38.921875 52.425781 C 48.949219 54.824219 53.890625 63.953125 53.890625 76.976562 C 53.890625 97.78125 44.3125 106.757812 30.691406 106.757812 L 0.0078125 106.757812 Z M 0.0078125 0.0429688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6e0fb8cab0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 54,
    y: 0,
    height: 107
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9b84c04500"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 417.753906 8.042969 L 473.347656 8.042969 L 473.347656 116.417969 L 417.753906 116.417969 Z M 417.753906 8.042969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d12ddc5646"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 417.753906 89.910156 L 417.753906 8.042969 L 434.660156 8.042969 L 434.660156 89.011719 C 434.660156 97.691406 439.757812 101.574219 446.039062 101.574219 C 453.667969 101.574219 457.261719 96.492188 457.113281 89.148438 L 457.113281 8.042969 L 473.132812 8.042969 L 473.132812 89.160156 C 473.132812 106.367188 461.308594 116.394531 445 116.394531 C 428.691406 116.394531 417.753906 108.015625 417.753906 89.910156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eb00cb0a7b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.753906 0.0429688 L 56.253906 0.0429688 L 56.253906 108.417969 L 0.753906 108.417969 Z M 0.753906 0.0429688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cb8616bb73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.753906 81.910156 L 0.753906 0.0429688 L 17.660156 0.0429688 L 17.660156 81.011719 C 17.660156 89.691406 22.757812 93.574219 29.039062 93.574219 C 36.667969 93.574219 40.261719 88.492188 40.113281 81.148438 L 40.113281 0.0429688 L 56.132812 0.0429688 L 56.132812 81.160156 C 56.132812 98.367188 44.308594 108.394531 28 108.394531 C 11.691406 108.394531 0.753906 100.015625 0.753906 81.910156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "51d2db62e3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 57,
    y: 0,
    height: 109
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6b73a53cbc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 484.730469 6.179688 L 537.902344 6.179688 L 537.902344 116.320312 L 484.730469 116.320312 Z M 484.730469 6.179688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5998bdc634"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 484.796875 87.515625 L 500.367188 87.066406 C 501.117188 95.144531 503.664062 102.636719 511.746094 102.636719 C 519.074219 102.636719 521.472656 96.207031 521.472656 90.210938 C 521.472656 83.917969 517.875 78.238281 511.746094 72.105469 L 500.507812 59.980469 C 491.828125 51.453125 486.445312 42.773438 486.445312 31.996094 C 486.445312 17.921875 494.972656 6.246094 512.03125 6.246094 C 524.757812 6.246094 535.535156 12.988281 536.582031 33.933594 L 521.761719 34.382812 C 520.710938 25.402344 518.015625 19.722656 511.285156 19.722656 C 505.140625 19.722656 501.855469 24.054688 501.855469 30.796875 C 501.855469 36.929688 507.398438 42.621094 512.632812 48.304688 L 522.957031 59.082031 C 532.386719 68.660156 537.621094 77.789062 537.621094 89.3125 C 537.621094 104.722656 528.042969 116.25 511.582031 116.25 C 495.425781 116.25 485.835938 105.621094 484.796875 87.515625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9f12dab336"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.765625 0.179688 L 53.761719 0.179688 L 53.761719 110.320312 L 0.765625 110.320312 Z M 0.765625 0.179688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d397a2c5fc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.796875 81.515625 L 16.367188 81.066406 C 17.117188 89.144531 19.664062 96.636719 27.746094 96.636719 C 35.074219 96.636719 37.472656 90.207031 37.472656 84.210938 C 37.472656 77.917969 33.875 72.238281 27.746094 66.105469 L 16.507812 53.980469 C 7.828125 45.453125 2.445312 36.773438 2.445312 25.996094 C 2.445312 11.921875 10.972656 0.246094 28.03125 0.246094 C 40.757812 0.246094 51.535156 6.988281 52.582031 27.933594 L 37.761719 28.382812 C 36.710938 19.402344 34.015625 13.722656 27.285156 13.722656 C 21.140625 13.722656 17.855469 18.054688 17.855469 24.796875 C 17.855469 30.929688 23.398438 36.621094 28.632812 42.304688 L 38.957031 53.082031 C 48.386719 62.660156 53.621094 71.789062 53.621094 83.3125 C 53.621094 98.722656 44.042969 110.25 27.582031 110.25 C 11.425781 110.25 1.835938 99.621094 0.796875 81.515625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a1b950e5a9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 54,
    y: 0,
    height: 111
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fa3c231ac2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 546.445312 6.179688 L 599.617188 6.179688 L 599.617188 116.320312 L 546.445312 116.320312 Z M 546.445312 6.179688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7cc7dfe1a6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 546.746094 87.515625 L 562.308594 87.066406 C 563.058594 95.144531 565.605469 102.636719 573.683594 102.636719 C 581.015625 102.636719 583.410156 96.207031 583.410156 90.210938 C 583.410156 83.917969 579.816406 78.238281 573.683594 72.105469 L 562.46875 59.980469 C 553.789062 51.453125 548.394531 42.773438 548.394531 31.996094 C 548.394531 17.921875 556.925781 6.246094 573.996094 6.246094 C 586.71875 6.246094 597.496094 12.988281 598.542969 33.933594 L 583.722656 34.382812 C 582.671875 25.402344 579.976562 19.722656 573.246094 19.722656 C 567.101562 19.722656 563.816406 24.054688 563.816406 30.796875 C 563.816406 36.929688 569.351562 42.621094 574.59375 48.304688 L 584.921875 59.082031 C 594.347656 68.660156 599.59375 77.789062 599.59375 89.3125 C 599.59375 104.722656 590.015625 116.25 573.554688 116.25 C 557.386719 116.25 547.808594 105.621094 546.769531 87.515625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5bfcf2eaf9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.632812 0.179688 L 53.617188 0.179688 L 53.617188 110.320312 L 0.632812 110.320312 Z M 0.632812 0.179688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "21babc1545"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.746094 81.515625 L 16.308594 81.066406 C 17.058594 89.144531 19.605469 96.636719 27.683594 96.636719 C 35.015625 96.636719 37.410156 90.207031 37.410156 84.210938 C 37.410156 77.917969 33.816406 72.238281 27.683594 66.105469 L 16.46875 53.980469 C 7.789062 45.453125 2.394531 36.773438 2.394531 25.996094 C 2.394531 11.921875 10.925781 0.246094 27.996094 0.246094 C 40.71875 0.246094 51.496094 6.988281 52.542969 27.933594 L 37.722656 28.382812 C 36.671875 19.402344 33.976562 13.722656 27.246094 13.722656 C 21.101562 13.722656 17.816406 18.054688 17.816406 24.796875 C 17.816406 30.929688 23.351562 36.621094 28.59375 42.304688 L 38.921875 53.082031 C 48.347656 62.660156 53.59375 71.789062 53.59375 83.3125 C 53.59375 98.722656 44.015625 110.25 27.554688 110.25 C 11.386719 110.25 1.808594 99.621094 0.769531 81.515625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c18f3f7a77"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 54,
    y: 0,
    height: 111
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "38d27c53d5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 606,
    y: 0,
    height: 123
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 21, 86)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#38d27c53d5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ab28fa6140)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#51b93e92c8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 75, 77)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#10efe85049)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#82c4f97b87)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2e52747a66)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -331.872,
    width: 1119.744,
    fill: "#e2205e",
    y: -270.288996,
    height: 509.32798,
    fillOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#78d8cc7e1c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#022269d297)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 5, 8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3bbb9ce515)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4bbce9fb7f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#703334e93f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -261.872,
    width: 1119.744,
    fill: "#e2205e",
    y: -201.288996,
    height: 509.32798,
    fillOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1efe0e07f8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3cb65f3595)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 5, 8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8b3f12c174)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bb71c3dab4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cd0a694cc4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -261.872,
    width: 1119.744,
    fill: "#e2205e",
    y: -201.288996,
    height: 509.32798,
    fillOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#07fe184d87)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3d5de03443)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 143, 8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#75829fb380)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#52cd8a1a89)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#576a87d21b)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -399.872,
    width: 1119.744,
    fill: "#e2205e",
    y: -201.288996,
    height: 509.32798,
    fillOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#53e1ff4c8b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a36bfbd94c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 206, 7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae736d1612)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bea5ad2ab8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6a2f725c59)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -462.872,
    width: 1119.744,
    fill: "#e2205e",
    y: -200.288996,
    height: 509.32798,
    fillOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9a0ef126f3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5eed1da130)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 283, 8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#67f022ecab)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#541e3474d9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5dab292172)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -539.872,
    width: 1119.744,
    fill: "#e2205e",
    y: -201.288996,
    height: 509.32798,
    fillOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a6791d0dc5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#34741e634a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 351, 8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6e0fb8cab0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2098c57a7b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dcd19248c0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e2205e",
    d: "M 0.0078125 0.0429688 L 53.890625 0.0429688 L 53.890625 106.753906 L 0.0078125 106.753906 Z M 0.0078125 0.0429688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9b84c04500)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d12ddc5646)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 417, 8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#51d2db62e3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eb00cb0a7b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb8616bb73)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e2205e",
    d: "M 0.753906 0.0429688 L 56.128906 0.0429688 L 56.128906 108.417969 L 0.753906 108.417969 Z M 0.753906 0.0429688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6b73a53cbc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5998bdc634)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 484, 6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a1b950e5a9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9f12dab336)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d397a2c5fc)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -740.872,
    width: 1119.744,
    fill: "#e2205e",
    y: -199.288996,
    height: 509.32798,
    fillOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fa3c231ac2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7cc7dfe1a6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 546, 6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c18f3f7a77)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5bfcf2eaf9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#21babc1545)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -802.872,
    width: 1119.744,
    fill: "#e2205e",
    y: -199.288996,
    height: 509.32798,
    fillOpacity: 1
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBarbuss);
export default __webpack_public_path__ + "static/media/logo_barbuss.3a2106908f56ad188fc477f1b16eb2ec.svg";
export { ForwardRef as ReactComponent };